/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import * as React from 'react';
import UserLink from '../../../../links/UserLink';
import { BettingUser, BetView, TournamentRoundGroupMember } from '../../../../services/betting';
import { BetComponent } from '../../../Bet/index';

interface LeafGridRowProps {
    trgm?: TournamentRoundGroupMember;
    user?: BettingUser;
    bets?: BetView[];
    startColumn: number;
    columnCount: number;
}

export const LeafGridRow: React.FC<LeafGridRowProps> = (props) => {
    if (props.trgm && props.bets && props.user) {
        return (
            <tr>
                <td className="py-1 d-none d-md-table-cell">
                    {props.trgm.rank}
                    <br />
                    <small className="text-sm-center">({props.trgm.absoluteRank})</small>
                </td>
                <td className="py-1 align-middle ps-0 pe-0 d-sm-none">
                    <UserLink id={String(props.user.id)} name={props.user.name} maxWidth={70} />
                </td>
                <td className="py-1 align-middle ps-0 pe-0 d-none d-sm-table-cell">
                    <UserLink id={String(props.user.id)} name={props.user.name} maxWidth={70} />
                </td>
                {props.bets.map((bet, index) => {
                    if (index >= props.startColumn && index < props.startColumn + props.columnCount) {
                        return (
                            <td
                                key={index}
                                className="py-1 text-center align-middle text-nowrap border-left ps-1 pe-1 "
                            >
                                <BetComponent bet={bet} />
                            </td>
                        );
                    }
                    return null;
                })}
                <td className="py-1 pe-0 ps-1 border-left align-middle">
                    <span className="btn-r1--points p-0">{props.trgm.points}</span>
                </td>
            </tr>
        );
    } else {
        return null;
    }
};
